import { Outlet } from "react-router";

export function LegalLayout() {
  return <Outlet />;
}
